const USE_PRODUCTION_API = true;

export const BASE_URL = USE_PRODUCTION_API
  ? 'https://api.honorhealthnetworkmarketing.com'
  : 'https://leaderboard-back-end-940a811ef01d.herokuapp.com';
